// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dctApproveDownload_wrapper__1-OTi","condition":"dctApproveDownload_condition__23_TZ"};